import { STORE_LISTING } from '../constants/actionTypes'

export const storeListing = listing => ({
  type: STORE_LISTING,
  listing,
})
